<div class="footer-container container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
  <img height="150px" src="assets/images/resized-retailstat-icon.png" alt="Retailstat Logo"/>
  <span [innerHTML]="'FOOTER.COPYRIGHT' | translate:{ year: currentYear, link: 'https://retailstat.com' }"></span>
</div>
